export const TOPIC_PARTIAL_PATHS = {
    16: "dokument",
    40: "revisormal",
} as const;

export const LEGACY_PARTIAL_PATHS = ["revisjonsberetning", "erklaering"];

export const LEGACY_PATHS = [
    "kostra-art",
    "kostra-funksjon",
    "revisjonsprogram",
    "prosess",
    "sjekkliste",
    "dokumentpakke",
    "kalkulator",
    "skjema",
    "regnskap-noter",
    "revisjonsberetning",
    "erklaering",
    "rettsavgjoerelse",
    "vedtak",
    ...LEGACY_PARTIAL_PATHS,
];

export const TOPIC_TYPE_PATHS = {
    15: "praktika",
    30: "art",
    31: "funksjon",
    32: "direktiv",
    33: "qna",
    29: "tema",
    68: "faglitteratur",
    99: "lignings-abc",
    6: "kontoplan",
    47: "sjekkliste-maler",
    17: "regneark-regnskap",
    5: "haandbok",
    2: "lov",
    11: "standard",
    3: "forskrift",
    25: "lovkommentar",
    8: "artikkel-uttalelse",
    4: "forarbeid",
    10: "skatteavtale",
    14: "avgjoerelse",
    45: "nyhet",
    98: "juridisk-vejledning",
    1001: "portal",
    1002: "portal",
    1003: "portal",
    ...TOPIC_PARTIAL_PATHS,
} as const;

// Topic type names exactly as DibApp2020 receives them in
// /dibapi/home response.filterlist.types (DB table TOPIC_TYPE).
// We have no such list, so they are hardcoded here. The values must stay
// byte-identical to the Type.* values in locale/nb.json — headings are
// reverse-looked-up against nb.json to find their Lokalise key for
// translation (same convention as DibApp2020's slider-relations).
export const TOPIC_TYPE_DB_NAMES: Record<string, string> = {
    2: "Lov",
    3: "Forskrift",
    4: "Forarbeid",
    5: "Håndbok",
    6: "Kontoplan",
    8: "Uttalelse",
    10: "Skatteavtale",
    11: "Standard",
    14: "Avgjørelse",
    15: "Praktika",
    16: "Dokumentmal",
    17: "Regneark / Regnskap",
    25: "Lovkommentar",
    29: "Tema",
    30: "Art",
    31: "Funksjon",
    32: "Direktiv",
    33: "Q&A",
    40: "Revisormal",
    45: "Nyhet",
    47: "Sjekkliste / Maler",
    68: "Faglitteratur",
    98: "Juridisk Vejledning",
    99: "Skatte-ABC",
    1001: "Portal-Oppslag",
    1002: "Portal-Verktøy",
    1003: "Portal-Kilder",
};

const PATHS = {
    ROOT: "/",
    FILE: "file",
    NOT_IMPLEMENTED: "ikke-implementert",
};

export const ALL_TOPIC_TYPES = new Set(
    (Object.values(TOPIC_TYPE_PATHS) as string[]).concat(LEGACY_PATHS)
);

export const ALL_PARTIAL_TYPES = new Set(
    (Object.values(TOPIC_PARTIAL_PATHS) as string[]).concat(LEGACY_PARTIAL_PATHS)
);

export function isTopicTypePathKey(
    key: number
): key is keyof typeof TOPIC_TYPE_PATHS {
    return key in TOPIC_TYPE_PATHS;
}

export const DASHBOARD_PATHS = [
    "/",
    "/dashboard",
    "/my-work",
    "/content",
    "/chat-search",
];

export const isDashboardPath = (pathname: string) =>
    DASHBOARD_PATHS.some((p) => pathname === p || pathname.startsWith(`${p}/`));

export default {
    ...PATHS,
    ...TOPIC_TYPE_PATHS,
};
